var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.modIsPending || _vm.lists.length !== 0)?_c('bh-flow-holder',[_c('bh-flow-generator',{attrs:{"root":"","value":_vm.value,"event-handler":_vm.onDropItem},on:{"drop":_vm.onDropItem}})],1):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }